import _ from "lodash";
import React from "react";
import requireAuth from "../auth/requireAuth";
import { connect } from "react-redux";
import ReactTable from "react-table-v6";
import { Button, Grid } from "semantic-ui-react";
import {
  fetchReports,
  fetchUsers,
  fetchCompanies,
  selectedReport,
} from "../../actions";

import "react-table-v6/react-table.css";
import { tiracentos } from "../../utils/tools/tiracentos";
import ReportModalClass from "./ReportModalClass";
import OrderServiceModalClass from "./OrderServiceModalClass";

class ReportTableGrid extends React.Component {

  constructor(props) {
    super(props);
    this.state = { isToggle: false }; //Arquivados
    this.handleToggle = this.handleToggle.bind(this);

    this.state = { isToggle2: false }; //Deletados
    this.handleToggle2 = this.handleToggle2.bind(this);

    this.state = { isToggle3: true }; //Ativos
    this.handleToggle3 = this.handleToggle3.bind(this);
  }

  handleToggle(e) {
    e.preventDefault();
    this.setState({ isToggle: true });
    this.setState({ isToggle2: false });
    this.setState({ isToggle3: false });
  }

  handleToggle2(e) {
    e.preventDefault();
    this.setState({ isToggle2: true });
    this.setState({ isToggle: false });
    this.setState({ isToggle3: false });
  }

  handleToggle3(e) {    
    e.preventDefault();
    this.setState({ isToggle3: true });
    this.setState({ isToggle: false });
    this.setState({ isToggle2: false });
    //this.handleToggle(e);
    //this.handleToggle2(e)
    
  }

  componentDidMount() {
    if (this.props.reports.length === 0) {
      this.props.fetchUsers();
      this.props.fetchReports();
      this.props.fetchCompanies();
    }
  }

  renderGrid() {
    const onRowClick = (state, rowInfo) => {
      return {
        onClick: (e) => {
          this.props.selectedReport(rowInfo.original);
        },
      };
    };

    const ptBRFormatter = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    const today = new Date();

    const { userData, currentUserId, reports } = this.props;

    var arrayAnteriores = [];

    if (!reports) {
      return <div className="ui active centered inline loader" />;
    }

    const empUserFind = [];
    userData.map((user) => {
      if (user.id === currentUserId) {
        empUserFind.push(user.companies);
      }
    });    

    const findCompaniesFromUser = _.map(_.map(empUserFind[0]), "id");

    const findCompaniesFromReport = _.map(reports);

    // const reportData = _.filter(_.map(reports));

    // const reportData = [];
    // _.forEach(findCompaniesFromUser, function (empUser) {
    //   _.forEach(findCompaniesFromReport, function (listReport) {
    //     // if (listReport.company.id === empUser)
    //     console.log(listReport.company.id);
    //   });
    //   // if (_.map(reports, "company.id") === empUser) {
    //   //   reportData.push(findCompaniesFromReport);
    //   // }
    //
    //   console.log(empUser);
    // });

    const reportData = [];
    for (var i = 0; i < findCompaniesFromUser.length; i++) {
      var empUser = findCompaniesFromUser[i];
      //console.log(empUser);

      for (var j = 0; j < findCompaniesFromReport.length; j++) {
        if (findCompaniesFromReport[j].company.id == empUser && findCompaniesFromReport[j].isReleased) {
          reportData.push(findCompaniesFromReport[j]);
        }
      }
    }

    var j = 0;
        for (var i=0; i < this.props.reports.length; i++){
          if(this.props.reports[i].oldReport){
            arrayAnteriores[j] = {id:this.props.reports[i].oldReport.id};
            j++;
          }
        }

        //const reportDataFinal = this.state.isToggle
        //? _.filter(reportData, { isArchived: true })
        //: _.filter(reportData, { isArchived: false });

        let reportDataFinal = "";

        if(this.state.isToggle){
          console.log('hank2');
          reportDataFinal = _.filter(reportData, 
            function (o) {
                return o.isDeleted || o.isArchived;
            });
        }else if(this.state.isToggle2){ // AQUI É O SO DELETADOS - SO COMENTEI O BOTAO QUE CHAMA: onClick={this.handleToggle2}
          reportDataFinal = _.filter(reportData, { isDeleted: true });
        }else if(this.state.isToggle3){
          reportDataFinal =  _.filter(reportData, { isDeleted: false, isArchived: false });
        }
    //console.log("FINALSZ", findCompaniesFromReport);

    return (
      <>
        <br />
        <ReactTable
          keyField="id"
          getTdProps={onRowClick}
          filterable
          showPagination={true}
          minRows={0}
          previousText="<"
          nextText=">"
          rowsText=""
          pageText="Página"
          ofText="de"
          noDataText="Nenhuma Informação"
          loadingText="Buscando dados..."
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id])
              .toLowerCase()
              .indexOf(filter.value.toLowerCase()) > -1
          }
          defaultPageSize={10}
          className="-striped -highlight"
          data={reportDataFinal}
          resolveData={(data) => data.map((row) => row)}
          columns={[
            {
              Header: "Empresa",
              accessor: "company.fantasyName",
              filterMethod: (filter, row) => {  
                let pattern = new RegExp(filter.value, 'gi');
                let pattern2 = new RegExp(tiracentos(filter.value), 'gi');                 
                              
                return (row[filter.id].match(pattern) || tiracentos(row[filter.id]).match(pattern2)); 
              }, 
            },
            {
              Header: "Sigla",
              accessor: "company.initials",
              filterMethod: (filter, row) => {  
                let pattern = new RegExp(filter.value, 'gi');
                let pattern2 = new RegExp(tiracentos(filter.value), 'gi');                 
                              
                return (row[filter.id].match(pattern) || tiracentos(row[filter.id]).match(pattern2)); 
              }, 
            },
            {
              Header: "Título do Laudo",
              accessor: "title",
              Cell: (rowInfo) => {
                if(rowInfo.original.isDeleted){
                  const tituloDel = "D- ";
                  const titulo = rowInfo.value;
                  return <span><span style={{color:'red', fontWeight:'bold'}} >{tituloDel}</span>{titulo}</span>;
                }else{
                  const titulo = rowInfo.value;
                  return <span>{titulo}</span>;
                }                
              },
              filterMethod: (filter, row) => {  
                let pattern = new RegExp(filter.value, 'gi');
                let pattern2 = new RegExp(tiracentos(filter.value), 'gi');                 
                              
                return (row[filter.id].match(pattern) || tiracentos(row[filter.id]).match(pattern2)); 
              }, 
            },
            {
              Header: "Ordem de Serviço",
              id: "orderService",
              accessor: (d) =>{ 
                if(d.orderService){
                  return d.orderService.title;
                }               
              },
              maxWidth: 170,
              filterMethod: (filter, row) => {                 
                if(row[filter.id] != null){
                  let pattern = new RegExp(filter.value, 'gi');
                  let pattern2 = new RegExp(tiracentos(filter.value), 'gi');                 
                                
                  return (row[filter.id].match(pattern) || tiracentos(row[filter.id]).match(pattern2)); 
                }else{          
                  return false;                  
                }
              },    
            },
            {
              Header: "Emissão",
              id: "startDate",
              maxWidth: 90,
              accessor: (d) => {
                return d.startDate;
              },
              Cell: (d) => {
                const custom_date = d.value;
                return <span>{ptBRFormatter.format(new Date(custom_date))}</span>;
              },
              filterMethod: (filter, row) => {
                if (filter.value.match(/\//)) {   

                  let filtroArr = filter.value.split("/");

                  if(filtroArr.length == 3){
                    let pattern = new RegExp(filtroArr[2]  + "-" + filtroArr[1] + "-" + filtroArr[0]);
                    return row[filter.id].match(pattern);
                  }else if(filtroArr.length == 2){
                    if(filtroArr[1] == ""){
                      let pattern = new RegExp("-" + filtroArr[0]);
                      return row[filter.id].match(pattern);
                    }else if(filtroArr[1].length == 2){
                      let pattern = new RegExp("-" + filtroArr[1] + "-" + filtroArr[0]);
                      return row[filter.id].match(pattern);
                    }else if(filtroArr[1].length == 4){
                      let pattern = new RegExp(filtroArr[1] + "-" + filtroArr[0]+ "-");
                      return row[filter.id].match(pattern);
                    }
                  }
                }else{
                  if(filter.value.length == 2){
                    var pattern = new RegExp("-" + filter.value);
                  }else{
                    var pattern = new RegExp(filter.value);
                  }
                  
                  return row[filter.id].match(pattern);
                }
              },
            },
            {
              Header: "Validade",
              id: "endDate",
              maxWidth: 90,
              accessor: (d) => {
                return d.endDate;
              },
              Cell: (d) => {
                const custom_date = d.value;
                return <span>{ptBRFormatter.format(new Date(custom_date))}</span>;
              },
              filterMethod: (filter, row) => {
                if (filter.value.match(/\//)) {  

                  let filtroArr = filter.value.split("/");

                  if(filtroArr.length == 3){
                    let pattern = new RegExp(filtroArr[2]  + "-" + filtroArr[1] + "-" + filtroArr[0]);
                    return row[filter.id].match(pattern);
                  }else if(filtroArr.length == 2){
                    if(filtroArr[1] == ""){
                      let pattern = new RegExp("-" + filtroArr[0]);
                      return row[filter.id].match(pattern);
                    }else if(filtroArr[1].length == 2){
                      let pattern = new RegExp("-" + filtroArr[1] + "-" + filtroArr[0]);
                      return row[filter.id].match(pattern);
                    }else if(filtroArr[1].length == 4){
                      let pattern = new RegExp(filtroArr[1] + "-" + filtroArr[0]+ "-");
                      return row[filter.id].match(pattern);
                    }
                  }
                }else{
                  if(filter.value.length == 2){
                    var pattern = new RegExp("-" + filter.value);
                  }else{
                    var pattern = new RegExp(filter.value);
                  }
                  
                  return row[filter.id].match(pattern);
                }
              },
              getProps: (state, rowInfo) => ({
                style: {
                  backgroundColor:
                  today > new Date(rowInfo.original.endDate)
                  ? "#ffad99"
                  : 11 > (Math.round((new Date(rowInfo.original.endDate) - today) / (1000 * 60 * 60 * 24)))
                  ? "#ffb84d"
                  : 31 > (Math.round((new Date(rowInfo.original.endDate) - today) / (1000 * 60 * 60 * 24)))
                  ? "#ffff4d"
                  :null,
                },
              }),
            },
            {
              Header: "Tipo de Serviço",
              id: "services",
              // maxWidth: 200,
              accessor: (d) =>
                d.services.map((service) => {
                  return service.name;
                }),
              Cell: (props) =>
                props.original.services.map((service, index) => {
                  return (
                    <div key={index}>
                      <span className="ui label">{service.name}</span>
                      <br />
                    </div>
                  );
                }),
                filterMethod: (filter, row) => {  
                  let pattern = new RegExp(filter.value, "gi");                  
                  return row[filter.id][0].match(pattern) || tiracentos(row[filter.id][0]).match(pattern);                 
                },
            },
            {
              Header: "Tipo de Equipamento",
              id: "equipments",
              // maxWidth: 200,
              accessor: (d) =>
                d.equipments.map((equipment) => {
                  return equipment.name;
                }),
              Cell: (props) =>
                props.original.equipments.map((equipment, index) => {
                  return (
                    <div key={index}>
                      <span className="ui label">{equipment.name}</span>
                      <br />
                    </div>
                  );
                }),
                filterMethod: (filter, row) => {  
                  let pattern = new RegExp(filter.value, "gi");                  
                  return row[filter.id][0].match(pattern) || tiracentos(row[filter.id][0]).match(pattern);                 
                },
            },          
            {
              Header: "Status",
              accessor: "isApproved",
              maxWidth: 100,
              sortable: false,
              id: "isApproved",
              Cell: (props) =>
                props.value === true ? (
                  props.original.isDeleted ? (
                  <Grid>
                    <Grid.Column textAlign="center">
                      <Button
                        as="a"
                       // color="teal"
                        size="mini"
                        icon="thumbs up"
                       // target="_blank"
                       // rel="noreferrer"
                      />
                    </Grid.Column>
                  </Grid>
                  ) : (
                    <Grid>
                    <Grid.Column textAlign="center">
                      <Button
                        as="a"
                        color="teal"
                        size="mini"
                        icon="thumbs up"
                        target="_blank"
                        rel="noreferrer"
                      />
                    </Grid.Column>
                  </Grid>
                  )
                ) : (
                  props.original.isDeleted ? (
                  <Grid>
                    <Grid.Column textAlign="center">
                      <Button
                        as="a"
                       // color="red"
                        size="mini"
                        icon="thumbs down"
                       // target="_blank"
                       // rel="noreferrer"
                      />
                    </Grid.Column>
                  </Grid>
                  ) : (
                    <Grid>
                    <Grid.Column textAlign="center">
                      <Button
                        as="a"
                        color="red"
                        size="mini"
                        icon="thumbs down"
                        target="_blank"
                        rel="noreferrer"
                      />
                    </Grid.Column>
                  </Grid>
                  )
                ),
              filterMethod: (filter, row) => {
                if (filter.value === "all") {
                  return true;
                }
                if (filter.value === "true") {
                  return row[filter.id] === true;
                }
                if (filter.value === "false") {
                  return row[filter.id] === false;
                }
              },
              Filter: ({ filter, onChange }) => (
                <select
                  onChange={(event) => onChange(event.target.value)}
                  style={{ width: "100%" }}
                  value={filter ? filter.value : "all"}
                >
                  <option value="all">Todos</option>
                  <option value="true">Assinado</option>
                  <option value="false">Não Assinado</option>
                </select>
              ),
            },
            {
              Header: "Condição",
              accessor: "isNotSatisfactory",
              // filterable: false,
              sortable: false,
              maxWidth: 100,
              id: "isNotSatisfactory",
              Cell: (props) =>
                props.original.isNotSatisfactory === true ? (

                  (_.find(arrayAnteriores, {id:props.original.id})) ? (
                    props.original.isDeleted ? (
                    <Grid>
                      <Grid.Column textAlign="center">
                        <Button
                          as="a"
                         // color="purple"
                          size="mini"
                          icon="bug"
                        //  target="_blank"
                        //  rel="noreferrer"
                        />
                      </Grid.Column>
                    </Grid>
                    ) : (
                      <Grid>
                      <Grid.Column textAlign="center">
                        <Button
                          as="a"
                          color="purple"
                          size="mini"
                          icon="bug"
                          target="_blank"
                          rel="noreferrer"
                        />
                      </Grid.Column>
                    </Grid>
                    )
                  ) : (
                    props.original.isDeleted ? (
                    <Grid>
                      <Grid.Column textAlign="center">
                        <Button
                          as="a"
                        //  color="red"
                          size="mini"
                          icon="bug"
                        //  target="_blank"
                        //  rel="noreferrer"
                        />
                      </Grid.Column>
                    </Grid>
                    ) : (
                      <Grid>
                      <Grid.Column textAlign="center">
                        <Button
                          as="a"
                          color="red"
                          size="mini"
                          icon="bug"
                          target="_blank"
                          rel="noreferrer"
                        />
                      </Grid.Column>
                    </Grid>
                    )
                  )
                ) : (
                  props.original.isDeleted ? (
                  <Grid>
                    <Grid.Column textAlign="center">
                      <Button
                        as="a"
                      //  color="green"
                        size="mini"
                        icon="shield alternate"
                      //  target="_blank"
                      //  rel="noreferrer"
                      />
                    </Grid.Column>
                  </Grid>
                  ) : (
                    <Grid>
                    <Grid.Column textAlign="center">
                      <Button
                        as="a"
                        color="green"
                        size="mini"
                        icon="shield alternate"
                        target="_blank"
                        rel="noreferrer"
                      />
                    </Grid.Column>
                  </Grid>
                  )
                ),
              filterMethod: (filter, row) => {
                if (filter.value === "all") {
                  return true;
                }
                if (filter.value === "true") {
                  return row[filter.id] === true;
                }
                if (filter.value === "false") {
                  return row[filter.id] === false;
                }
              },
              Filter: ({ filter, onChange }) => (
                <select
                  onChange={(event) => onChange(event.target.value)}
                  style={{ width: "100%" }}
                  value={filter ? filter.value : "all"}
                >
                  <option value="all">Todos</option>
                  <option value="false">Satisfatório</option>
                  <option value="true">Insatisfatório</option>
                </select>
              ),
            },
            {
              Header: "Ações",
              columns: [
                {
                  id: "file.id",
                  filterable: false,
                  maxWidth: 280,
                  minWidth: 100,
                  sortable: false,
                  accessor: (e) => (
                    e.isDeleted ? (
                      <Button
                        className="ui left labeled mini icon button"
                        icon="eye slash outline"                        
                        content="Excluído - motivo técnico"
                      />
                    ) : /*e.isArchived ? ( // else if antes do else final no ternario
                      <Button
                        className="ui left labeled mini icon button"
                        icon="eye slash outline"                        
                        content="Assinar"
                      />
                    ) : */ (
                      <ReportModalClass
                      id={e.id}
                      title={e.title}
                      startDate={e.startDate}
                      endDate={e.endDate}
                      observation={e.observation}
                      file={e.file}
                      isApproved={e.isApproved}
                      movimentations={e.movimentations}
                    />
                    )
                  ),
                },
                {
                  id: "orderService.id",
                  filterable: false,
                  maxWidth: 95,
                  minWidth: 95,
                  accessor: (e) =>
                    e.orderService && !e.isDeleted ? ( // && !e.isArchived
                      <OrderServiceModalClass
                        id={e.orderService.id}
                        orderService={e.orderService.title}
                        //startDate={e.orderService.startDate}
                        //endDate={e.orderService.endDate}
                        observation={e.orderService.observation}
                        file={e.orderService.file}
                        //isApproved={e.isApproved}
                        //movimentations={e.movimentations}
                      />
                    ) : (
                      <Button
                        className="ui left labeled mini icon button"
                        icon="eye slash outline"                        
                        content="O.S."
                      />
                    ),
                }, 
              ],
            },
          ]}
        />
      </>
    );
  }
  

  render() {

    const styleDel = {
      color: 'red',  
      fontWeight: 'bold',  
      width: '8em',
      marginLeft: '0.2em',
      backgroundColor:'#F9F463',
      border: '1px',
      borderRadius: '4px',
      padding: '0.5em',
      height:'0.8em',
      fontSize: '10px',

    };

    const styleRight = {
      textAlign:'right',
      display:'block',
      //color: 'red',  
      //fontWeight: 'bold',  
      //width: '8em',
      //marginBottom: '2em',
      //backgroundColor:'#F9F463',
      //border: '1px',
      //borderRadius: '4px',
      //padding: '0.5em',
      //height:'0.8em',
      //fontSize: '10px',

    };

    const styleInline = {
      float:'right',
      //color: 'red',  
      //fontWeight: 'bold',  
      //width: '8em',
      //marginBottom: '2em',
      //backgroundColor:'#F9F463',
      //border: '1px',
      //borderRadius: '4px',
      //padding: '0.5em',
      //height:'0.8em',
      //fontSize: '10px',

    };

    const stylePadTop = {
      //float:'right',
      //color: 'red',  
      //fontWeight: 'bold',  
      //width: '8em',
      marginTop:'2em',
      //backgroundColor:'#F9F463',
      //border: '1px',
      //borderRadius: '4px',
      //padding: '0.5em',
      //height:'0.8em',
      //fontSize: '10px',

    };

    const floatRight = { 
      float:'right',
      paddingRight: '2em',
      fontWeight: 'bold',
      fontSize:'18px'
    };

    const tenDays = {      
      marginBottom: '0.2em',
      backgroundColor:'#ffb84d',
      textAlign:'center',
      //float:'left',
      //border: '1px',
      //borderRadius: '4px',
      marginRight: '1em',
      padding:'0.5em',
      width:'80px',
      float:'right',
      //height:'0.8em',
      //fontSize: '10px',
    };


    const thirtyDays = {      
      marginBottom: '0.2em',
      backgroundColor:'#ffff4d',
      textAlign:'center',
      //border: '1px',
      //borderRadius: '4px',
      marginRight: '1em',
      padding:'0.5em',
      width:'80px',
      float:'right',
      //height:'0.8em',
      //fontSize: '10px',
    };

    const expired = {
      marginBottom: '0.2em',
      backgroundColor:'#ffad99',
      textAlign:'center',
      //border: '1px',
      //borderRadius: '4px',
      marginRight: '3em',
      padding:'0.5em',
      width:'80px',
      float:'right',
      //height:'0.8em',
      //fontSize: '10px',

    }

    const heavy = {
      fontWeight:'bold',
      marginRight:'1em',
      fontSize:'18px'
    }

    return (
      <div className="ui centered grid">
        <div className="ui fifteen wide column">
          <div className="ui row">
            <div className="sixteen wide column left bottom aligned content">
              <h1>Laudos</h1>
            </div>
            <div className="sixteen wide column right bottom aligned content">
              <div className="ui label mini teal">
                <i className="thumbs up icon" />
                Assinado
              </div>

              <div className="ui label mini red ">
                <i className="thumbs down icon" />
                Não assinado
              </div>
              <span> 
                <span style = {styleDel}>D- Deletado</span>
              </span>

              <div className="three wide column" style={styleRight}>                  
              {/*  <div className="" style={styleInline}>                
                  <Button
                          as="a"
                          color="red"
                          size="mini"
                          //icon="thumbs up"
                          //target="_blank"
                          content="Deletados"
                          rel="noreferrer"
                          onClick={this.handleToggle2}
                        />
                </div>  */}             
                <div className="" style={styleInline}>
                  <Button
                          as="a"
                          color="blue"
                          size="mini"
                          //icon="thumbs up"
                          //target="_blank"
                          content="Arquivados"
                          rel="noreferrer"
                          onClick={this.handleToggle}
                        />
                </div>                
                <div className="" style={styleInline}>
                  <Button
                          as="a"
                          color="green"
                          size="mini"
                          //icon="thumbs up"
                          //target="_blank"
                          title="Laudos ativos"
                          content="Ativos"
                          rel="noreferrer"
                          onClick={this.handleToggle3}
                        />
                </div>  
                <div className="" style={styleInline}>
                  <span style={heavy}>Filtrar por</span> 
                </div>  
                <div style={expired}>Vencido</div>
                <div style={thirtyDays}>30 dias</div>  
                <div style={tenDays}>10 dias</div> 
                <div style={floatRight}>Vencendo em até: </div>          
              </div><br />
            </div>
          </div>
          <div className="ui sixteen wide column" style={stylePadTop}>
            <div className="ui divider" />
          </div>
        </div>
        <div className="ui fifteen wide column">{this.renderGrid()}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userData: Object.values(state.users),
    currentUserId: state.auth.userId,
    reports: _.orderBy(Object.values(state.reports), "endDate", "desc"),
    userName: _.map(
      Object.values(state.reports),
      "movimentations[0].user.name"
    ),
  };
};

export default requireAuth(
  connect(mapStateToProps, {
    fetchUsers,
    fetchCompanies,
    fetchReports,
    selectedReport,
  })(ReportTableGrid)
);
